import { call, put } from 'redux-saga/effects';
import { Saga } from 'custom-types/saga';

import { addNegativeToast, errorIdentifier } from 'modules/toastContainer';
import {
  analyticsBasePageData,
  analyticsBasePageDataError,
} from 'modules/experiments/ducks/actions';
import { ExperimentsAction, BasePageExperimentData } from 'modules/experiments/types';
import { getExperimentsTranslations } from 'modules/experiments/utils';
import { fetchExperimentAnalyticsBasePage } from 'api/ExperimentsAPI';

type ExperimentAnalyticsSaga = Saga<
  ExperimentsAction<Record<string, unknown>, BasePageExperimentData>
>;

type FetchBasePageExperimentData = {
  data: {
    experiment: BasePageExperimentData;
  };
};

export function* setBasePageDataSaga({
  experimentId,
}: ExperimentsAction<{ experimentId: number }>): ExperimentAnalyticsSaga {
  try {
    const {
      data: { experiment },
    }: FetchBasePageExperimentData = yield call(fetchExperimentAnalyticsBasePage, experimentId);

    yield put(analyticsBasePageData(experiment));
  } catch (error) {
    yield put(analyticsBasePageDataError());

    const errorMessage = yield call(
      getExperimentsTranslations,
      'errorMessage.fetchExperimentAnalytics',
    );

    yield put(
      addNegativeToast(
        errorMessage,
        errorIdentifier({
          errorMessage,
          source: 'setBasePageDataSaga',
          error,
          additional: { experimentId },
        }),
      ) as any,
    );
  }
}
